const config = {
  key: {
    user: "___managed_medic_user",
    token:"managedmedics_access_user",
    refreshToken: "managedmedics_refresh_user",
    jobInformation: "managedmedics_job_info"
  },
};

export default config;
